import { render, staticRenderFns } from "./ReportActives.vue?vue&type=template&id=8ef84284"
import script from "./ReportActives.vue?vue&type=script&lang=js"
export * from "./ReportActives.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports